<template>
  <section class="hero is-medium is-primary is-bold">
    <div class="hero-head"></div>
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          生存力スコアリング<br><span style="font-size: 1.5rem;">by SX-Score</span>
        </h1>
        <h2 class="subtitle" style="font-size: 0.8rem;">
          セカンドサイト株式会社が保有するデータから構築したAIが、あなたの生存力スコアを算出します。
        </h2>
      </div>
      <div class="container">

        <section style="padding: 1rem;">
          <b-field label="あなたの職業を教えてください">
            <b-select placeholder="選択してください"
                      v-model="dataInput.g_job_type">
              <option value="学生">学生</option>
              <option value="主婦">主婦</option>
              <option value="パート・アルバイト">パート・アルバイト</option>
              <option value="会社員">会社員</option>
              <option value="会社役員">会社役員</option>
              <option value="公務員">公務員</option>
              <option value="自営業・個人事業主">自営業・個人事業主</option>
              <option value="無職">無職</option>
              <option value="その他・不明">その他・不明</option>
            </b-select>
          </b-field>

          <b-field label="あなたの性別を教えてください">
            <b-select placeholder="選択してください"
                      v-model="dataInput.sex">
              <option value="0">男</option>
              <option value="1">女</option>
            </b-select>
          </b-field>

          <b-field label="あなたの年齢を教えてください">
            <b-input v-model="dataInput.age"
                     placeholder="30"
                     type="number"
                     min="0"
                     max="999">
            </b-input>
          </b-field>

          <b-field label="今の生活は充実していますか？">
            <b-select placeholder="選択してください"
                      v-model="dataInput.k_1">
              <option value="0">充実している</option>
              <option value="1">それなりに充実している</option>
              <option value="2">あまり充実していない</option>
              <option value="3">充実していない</option>
            </b-select>
          </b-field>

          <b-field label="人に流されるタイプですか？">
            <b-select placeholder="選択してください"
                      v-model="dataInput.k_2">
              <option value="0">流されない</option>
              <option value="1">あまり流されない</option>
              <option value="2">たまに流される</option>
              <option value="3">流される</option>
            </b-select>
          </b-field>

          <b-field label="運が良いと思いますか？">
            <b-select placeholder="選択してください"
                      v-model="dataInput.k_3">
              <option value="0">良いと思う</option>
              <option value="1">どちらかと言うと良いと思う</option>
              <option value="2">どちらかと言うと悪いと思う</option>
              <option value="3">悪いと思う</option>
            </b-select>
          </b-field>

          <b-field label="どのように生きていきたいですか？">
            <b-select placeholder="選択してください"
                      v-model="dataInput.k_4">
              <option value="0">太く短く</option>
              <option value="1">どちらかと言うと太く短く</option>
              <option value="2">どちらかと言うと細く長く</option>
              <option value="3">細く長く</option>
            </b-select>
          </b-field>

          <b-field label="あなたの収入を教えてください（万円）">
            <b-input v-model="dataInput.income"
                     placeholder="400"
                     type="number"
                     min="0"
                     max="99999999999999999999999999">
            </b-input>
          </b-field>

          <b-field label="今住んでいる郵便番号を教えてください">
            <b-input v-model="dataInput.postal_cd"
                     placeholder="1234567"
                     type="text"
                     minlength="7"
                     maxlength="7">
            </b-input>
          </b-field>

          <a class="button scoring is-primary is-medium is-fullwidth is-rounded" @click="scoring">スコアリング</a>

        </section>

      </div>

      <footer style="text-align: center;">
        <p style="font-size: 0.6rem;">Powered by</p>
        <a href="https://www.sxi.co.jp/" style="cursor: pointer;">
          <img src="../../static/logo_footer.png" alt="Logo" width="50%" height="50%">
        </a>
      </footer>
    </div>

    <div class="hero-foot"></div>

    <b-loading :is-full-page="true" :active.sync="loading"
               :can-cancel="false"></b-loading>
  </section>

</template>

<script>
import Loading from './snippets/Loading'

import {scoringRequest} from '../modules/request/scoring'
import BField from 'buefy/src/components/field/Field'
import BTableColumn from 'buefy/src/components/table/TableColumn'

export default {
  name: 'Scoring',
  components: {
    BTableColumn,
    BField,
    'loading': Loading
  },
  data () {
    return {
      loading: false,
      dataInput: {
        id: 1,
        sex: null,
        age: null,
        income: null,
        postal_cd: null,
        g_job_type: null,
        k_1: null,
        k_2: null,
        k_3: null,
        k_4: null
      }
    }
  },
  methods: {
    async scoring () {

      const inputs = this.dataInput

      for (let key in inputs) {
        if (inputs[key] == null) {
          this.$toast.open({
            message: '未入力の項目があります',
            type: 'is-warning'
          })
          return false
        }
      }

      this.loading = true

      let response = await scoringRequest({data: [inputs]}, this)

      this.loading = false

      const result = response.data.scores[0]
      const totalRiskScore = result['total_risk_score']

      this.$router.push({path: 'result', query: {score: totalRiskScore}})
    }
  }
}
</script>

<style scoped>

  .hero {
    background: white;
    height: 100%;
  }

  .subtitle {
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #8F99A3;
  }

  a.button.scoring {
    margin: 2rem auto;
    background: transparent;
    border-color: white;
  }

</style>

<style>
  .label {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Scoring.vue